import { apiDeleteAuth } from '../../../../amplify/restClient';
import { putAccount } from '../../../../redux/reducers/data';
import { handleValidateAndDispatchAccount, maybeTriggerSync } from '../submitUtils';

// Handles deposits workflow submission, including provider tags and reconcile logic.
export default async function handleDepositsSubmit({ formValues, dispatch, setLoading, category }) {
  const { provider, accountArray, existingAccountsUpdated, reconcileAccounts, removedGCRequisitonId } = formValues;

  const accountsToSubmit = accountArray ? accountArray.filter((accountData) => accountData.isImported) : [formValues];

  // Submit accounts (retain async control flow)
  await Promise.all(
    accountsToSubmit.map(async (accountData) => {
      const flattened = { ...formValues, ...provider, ...accountData };

      if (provider) {
        flattened.tags = {
          ...flattened.tags,
          provider: {
            [accountData.providerName]: {
              providerAccountId: accountData.providerAccountId,
              providerInstitutionId: provider.providerInstitutionId,
              providerAccessId: provider.providerAccessId,
            },
          },
        };
      }

      const { resultDispatch, payload } = await handleValidateAndDispatchAccount({ category, userInput: flattened, dispatch, setLoading });
      if (resultDispatch?.payload?.accounts?.[0]?.id) {
        maybeTriggerSync({ payload, category, dispatch, accountId: resultDispatch.payload.accounts[0].id });
      }
    }),
  );

  if (existingAccountsUpdated?.length) {
    await Promise.all(existingAccountsUpdated.map((ea) => dispatch(putAccount({ data: ea, category }))));
  }

  if (reconcileAccounts && removedGCRequisitonId) {
    await apiDeleteAuth('myAPI', `deposits/requisition/${removedGCRequisitonId}`, {
      headers: { 'Content-Type': 'application/json' },
    });
  }
}
